import { get } from 'lodash-es'
import { getManagementRouteUrl } from 'universal/routes'
import { FUNDING_TYPES, EVALUATE_FUNDING_OPTIONS } from 'universal/cfs-card'
import { formatPartialCardNumber } from 'utils/formatter'

const { AUTO_RELOAD } = FUNDING_TYPES.ATU
const { ACTIVE } = EVALUATE_FUNDING_OPTIONS.STATUS

const getFundingSourceName = (fundingSource = {}) => {
  const { id = '', issuerName = '', classification = '' } = fundingSource
  // TODO To update the format of funding details
  if (id) {
    return `${issuerName} ${classification}`
  }
  return null
}

export const getAutoTopUpDetails = (card, fundingOptions) => {
  let autoTopUpDetails = {}

  const cardCapabilities = get(card, 'additionalDetails.capabilities', [])
  const hasAutoReloadCapability = cardCapabilities.includes(AUTO_RELOAD)

  if (card && hasAutoReloadCapability && fundingOptions) {
    const { editFundingSourceUrl } = getManagementRouteUrl(card)
    const fundingSource = get(fundingOptions, 'userPreferences.fundingSource', {})
    const fundingSourceName = getFundingSourceName(fundingSource)

    autoTopUpDetails = {
      editFundingSourceUrl,
      isAutoTopUpOn: fundingOptions?.fundingStatus === ACTIVE,
      fundingSourceName,
      cardNumberSuffix: formatPartialCardNumber(fundingSource?.lastNchars),
    }
  }

  return autoTopUpDetails
}

export const getAutoTopUpContentIdFromDetails = ({ isAutoTopUpOn = false } = {}) => {
  const contentPrefix = 'manageCard.autoTopUp'

  const topUpStatusContentId = isAutoTopUpOn ? 'on' : 'off'
  const headerContentId = `${contentPrefix}.title.${topUpStatusContentId}`
  const changeLinkContentId = `${contentPrefix}.link.change`
  const topUpContentId = `${contentPrefix}.content`

  return {
    headerContentId,
    changeLinkContentId,
    topUpContentId,
  }
}
